import leoraIcon from '../../assets/leoraIcon.png';
import instagramIcon from '../../assets/socials/instagram.png';
import whatsappIcon from '../../assets/socials/whatsapp.png';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={leoraIcon} alt="Leora" className="footer-logo-img" />
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Contacto</h4>
          <ul className="footer-list">
            <li>
              <a href="mailto:gerencia.leora@gmail.com" className="footer-link">
                gerencia.leora@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Síguenos</h4>
          <div className="footer-socials">
              <a
                href="https://www.instagram.com/leoraoficial.col"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <img src={instagramIcon} alt="Instagram" className="footer-social-icon" />
              </a>
              <a
                href="https://wa.me/+573216595562"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <img src={whatsappIcon} alt="WhatsApp" className="footer-social-icon" />
              </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} Leora. Todos los derechos reservados.</span>
      </div>
    </footer>
  );
}

export default Footer;
